<form [formGroup]="questionsForm" (ngSubmit)="onSubmit()">
  <div class="w-full flex flex-column gap-4">
    <!-- Institute Info -->
    <div class="w-full flex align-items-center gap-3">
      <div class="w-5rem h-5rem overflow-hidden border-circle flex-shrink-0">
        <img [src]="institute?.image ?? '../../../assets/images/university-icons/oxford.png'" alt="" class="w-full h-full"
          style="object-fit: cover;">
      </div>
      <div class="flex-1 flex flex-column gap-1">
        <b class="text-left font-medium text-2xl" style="color: #052647;">{{institute?.name}}</b>
        <p class="text-left font-normal text-sm" style="color: #575B68;">{{institute?.cityName+ ', '+
          institute?.countryName}}</p>
      </div>
    </div>

    <div class="w-full flex flex-column gap-2 w-full">
      <b class="inline-block w-auto py-1 font-medium">Select Course Level</b>
      <p-dropdown [options]="degreePrefs" optionValue="key"
        [ngClass]="{'ng-invalid ng-dirty' : submitted && ! questionsForm.get('courseLevel')?.value}" (onChange)="onCourseChange($event)"
        formControlName="courseLevel" optionLabel="name" class="w-full" placeholder="Select a Course" />
      <small class="ng-dirty ng-invalid text-red-500" *ngIf="questionsForm.get('courseLevel')?.invalid &&
      (submitted || questionsForm.get('courseLevel')?.touched)">
        Select Course
      </small>
    </div>
    <div class="w-full flex flex-column gap-2 w-full">
      <b class="inline-block w-auto py-2 font-medium">Select Course Name</b>
      <p-autoComplete #courseNameAutoComplete styleClass="fullWidth" [suggestions]="majors" (onSelect)="onCourseNameChange()" (onBlur)="onCourseNameChange()"
        [ngClass]="{'ng-invalid ng-dirty' : submitted && ! questionsForm.get('courseName')?.value}" (completeMethod)="filterIntendedMajors($event)"
        formControlName="courseName" class="w-full" placeholder="Enter Course Name" />
      <small class="ng-dirty ng-invalid text-red-500" *ngIf="questionsForm.get('courseName')?.invalid &&
      (submitted || questionsForm.get('courseName')?.touched)">
        Select/Enter Course Name
      </small>
    </div>

    <!-- Questions -->
    <div class="w-full flex flex-column gap-3">

      <!-- Loop for each question -->
      <div class="w-full flex flex-column gap-2" *ngFor="let i of [1,2,3,4,5]">
        <!-- Labels -->
        <div class="w-full flex gap-2">
          <b class="flex-1 text-left font-normal" style="color: #575B68;">Question - {{i}}</b>
          <b class="w-12rem text-left font-normal" style="color: #575B68;">Answer Word Limit</b>
        </div>

        <!-- Inputs -->
        <div class="w-full flex gap-2">
          <!-- Question -->
          <input [ngClass]="{'ng-invalid ng-dirty': getControl('question'+i)?.invalid &&
                     (submitted || getControl('question'+i)?.touched)}"
            type="text" [formControlName]="'question'+i" pInputText class="flex-1" />

          <!-- Word Limit -->
          <input [formControlName]="'question'+i+'WordLimit'"
            type="number"
            pInputText
            class="w-12rem"
            min="1"
            placeholder="Word Limit"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
        </div>

        <!-- Errors -->
        <small class="text-red-500" *ngIf="getControl('question'+i)?.invalid &&
                     (submitted || getControl('question'+i)?.touched)">
          Question {{i}} is required
        </small>

        <small class="text-red-500" *ngIf="getControl('question'+i+'WordLimit')?.invalid &&
               (submitted || getControl('question'+i+'WordLimit')?.touched)">
          Answer Word Limit is required when Question {{i}} has a value
        </small>
      </div>

    </div>

    <!-- Save Button -->
    <div class="w-full flex align-items-center justify-content-center">
      <p-button label="Save" [loading]="isLoading" class="w-full sm:w-12rem" styleClass="save_btn"
        (onClick)="onSubmit()" />
    </div>
  </div>
</form>
